import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClientAdfsConfig } from 'server/shared/models/customer';

@Injectable({
  providedIn: 'root',
})
export class AdfsService {
  private currentAdfsConfig: ClientAdfsConfig | null = null;

  constructor(private http: HttpClient) {}

  setAdfsConfig(config: ClientAdfsConfig): void {
    this.currentAdfsConfig = config;
  }

  login(): void {
    if (!this.currentAdfsConfig) {
      console.error('ADFS configuration not set. Call setAdfsConfig() first.');
      return;
    }
    const authUrl = this.buildAuthUrl(this.currentAdfsConfig);
    window.location.href = authUrl;
  }

  private buildAuthUrl(config: ClientAdfsConfig): string {
    const params = new URLSearchParams({
      response_type: 'code',
      redirect_uri: window.location.origin + '/',
      scope: 'openid',
      state: this.generateState(),
      nonce: this.generateNonce(),
      client_id: config.clientId,
      client_secret: '3s8LsZTnDKhA9LSRzNhkmm7tlBZvhnznPzwdLviN',
    });

    return `${config.authority}/oauth2/authorize?${params.toString()}`;
  }

  private generateState(): string {
    const state =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
    localStorage.setItem('adfs_state', state);
    return state;
  }

  /**
   * Generates a random nonce (Number used once) for the ADFS login that prevents replay attacks
   */
  private generateNonce(): string {
    const nonce =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
    return nonce;
  }

  private validateState(state: string): boolean {
    const storedState = localStorage.getItem('adfs_state');
    return storedState === state;
  }
}
